import { Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
  name: 'getStepTypeNameById',
  standalone: false
})
export class GetStepTypeNameByIdPipe implements PipeTransform {

  constructor(
    private appData: AppdataService
  ) { }
  transform(steTypeId: string): string {
    let steType = this.appData.steTypes.find((steType: any) => steType.id === steTypeId);
    return steType ? steType.name : steTypeId;
  }

}
